"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = void 0;
/**
 * Use to configure log levels.
 *
 * In MFE utilities, we configure the production build to strip out verbose and debug levels,
 * so you need to run local with overrides to see those.
 *
 * Apps should probably do the same. See `pure_funcs` on TerserPlugin for details.
 *
 * */
var LogLevel;
(function (LogLevel) {
    /** Useful for emitting detailed/step-by-step behavior tracing. */
    LogLevel["Verbose"] = "verbose";
    /** Useful for more limited behavior tracing and, by default, includes stack trace with messages. */
    LogLevel["Debug"] = "debug";
    /** Useful for info that devs may find useful to know to understand behavior, but doesn't suggest a problem in itself. */
    LogLevel["Info"] = "info";
    /** Useful for problems that the app can continue to function fine with, but that devs probably should look into and fix. */
    LogLevel["Warn"] = "warn";
    /** Useful to indicate a signfiicant problem that impairs app functionality (even if recoverable)--to signal devs should take action sooner rather than later. */
    LogLevel["Error"] = "error";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
